export default "__VITE_ASSET__CJwf5Ueu__"